// Invalidating a session also invalidates pending token requests from that identity.
export function sessionTokenCache(account, clock = Date.now) {
  let generation = 0, token = null, until = 0, pending = null;
  return {
    get generation() { return generation; },
    invalidate() { generation++; token = null; until = 0; pending = null; },
    async get() {
      if (token && clock() < until) return token;
      const epoch = generation;
      if (!pending) {
        const request = account.createJWT().then(result => {
          if (epoch !== generation) throw new Error('Session changed during token creation.');
          token = result.jwt; until = clock() + 10 * 60e3;
          return token;
        });
        pending = request;
        request.finally(() => { if (pending === request) pending = null; }).catch(() => {});
      }
      return pending;
    },
  };
}
